import React, { useEffect, useState } from 'react'

export const TodosList = () => {

    const[activity , setActivity]=useState("")
    const[listData, setlistData]=useState([])
    function addActivity(){
        //  setlistData([...listData,activity])
        //  console.log(listData)
        if(activity.length==0) {alert("Please Enter Your Activity...!!")}
        else{
        setlistData((listData)=>{
            const updatedList=[...listData,activity]
           // console.log(updatedList);
            setActivity('') 
           return updatedList;
        })
    }
    }
   
    function removeActivity(i){
            const updatedListData=listData.filter((element,id)=>{
                return i!=id;
            })  
            setlistData(updatedListData);
    }
    function removeAll(){
        setlistData([])
    }
  return (
   <>
    <div className='container'>
        <div className='todos'> <h1>Todos_List</h1> </div>

        <input className='input' type='text' placeholder='Create Activities...' value={activity} onChange={(e)=>setActivity(e.target.value)}/>
        <button className='button' onClick={addActivity}>Add</button> 
         
        <div className='all-list'>
        <h3 className='yours'>Your's Activities...</h3>
              {/* //lists............. */}
 
       
        {
            listData!=[] && listData.map((data,i)=>{
                return(
                    <>  <p > <li className='input'>{data}</li> <button className='button' onClick={()=>removeActivity(i)}>remove</button></p>
                      {/* <br/> */}
                      {/* <ul key={i}>
                        <li> {data}</li> <button onClick={()=>removeActivity(i)}>remove</button>
                      </ul> */}
                    </>
                )
            })
        }
        
          {listData.length >=1 && <button className='button' onClick={removeAll}>Remove All Activities</button> }
        </div>
    </div>
       
   </>
  )
}  
